import type { ServerPaginationConfig } from '@shared/types/module-config';

export const TOP_UP_PAGINATION: ServerPaginationConfig = {
  enabled: true,
  mode: 'server',
  pageParam: 'page',
  sizeParam: 'size',
  defaultSize: 25,
  firstPage: 0,
  sendPageIfDefault: true,
};

export const TOP_UP_ATTEMPTS_PAGINATION: ServerPaginationConfig = {
  enabled: true,
  mode: 'server',
  pageParam: 'page',
  sizeParam: 'size',
  defaultSize: 25,
  firstPage: 0,
  sendPageIfDefault: true,
};

export const TOP_UP_ROUTE_PATHS = {
  topUp: '/movements/top-up',
};

export const TOP_UP_API_PATHS = {
  purchases: '/v1/api/platform/purchases',
  purchaseDetail: '/v1/api/platform/purchases',
  approvePurchase: '/v1/api/platform/purchases',
  cancelPurchase: '/v1/api/platform/purchases',
  resendNotifBatch: '/v1/api/platform/purchases/resendNotifications/batch',
  resendNotifSingle: '/v1/api/platform/purchases/resendNotifications',
  attempts: '/v1/api/platform/purchases/attemps',
  payinStatus: '/v1/api/platform/gateway',
  changeStatusBatch: '/v1/api/platform/purchases/change-status/batch-list',
  paymentMethods: '/v1/api/platform/fraud/pm/pm-combo',
  createCasesBatch: '/v1/api/platform/help-center/cases/batch-create',
  chargebackLanguages: '/v1/api/platform/purchases/chargeback-generation-languages',
  proofOfPurchase: '/v1/api/platform/purchases/proofs',
};
